import { render, staticRenderFns } from "./columnFilter.vue?vue&type=template&id=24de417f&"
import script from "./columnFilter.vue?vue&type=script&lang=js&"
export * from "./columnFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/columnFilter.vue"
export default component.exports